import * as React from 'react'
import { Footer } from '../../../common/Footer'
import { EnterpriseTabType, Header } from '../Header'
import { css } from '@emotion/react'
import { mq } from 'plume-ui'

type Props = {
  activeTab?: EnterpriseTabType
  withHeaderBackground?: boolean
  children: React.ReactNode
}

export const EnterpriseTemplate: React.FC<Props> = ({
  withHeaderBackground = true,
  ...props
}) => {
  return (
    <>
      <Header activeTab={props.activeTab} background={withHeaderBackground} />
      <div
        css={css`
          margin-top: ${withHeaderBackground ? '70px' : '0'};
          ${mq.untilMedium} {
            margin-top: ${withHeaderBackground ? '55px' : '0'};
          }
        `}
      >
        <main>{props.children}</main>
      </div>
      <Footer noBorder />
    </>
  )
}
